import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
    secondary: {
      main: '#4C4C4C',
      
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
